import {
  IconEdit,
  IconMessageReply,
  IconRefresh,
  IconUser,
} from "@tabler/icons-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

import { useSelector } from "react-redux";
import { userSelector } from "@/redux/user/user.selector";
import { RolesLevels } from "@/services/types/types";
import { RoutesEnum } from "@/routes/enum/Routes";
import { useNavigate } from "react-router-dom";

export function NavMain() {
  const { userInfo } = useSelector(userSelector).ui;
  const navigate = useNavigate();

  const data = {
    navMain: [
      {
        title: "Home",
        url: RoutesEnum.HOME,
        items: [
          {
            title: "Actualizaciones",
            url: RoutesEnum.UPDATES,
            itemIcon: IconRefresh,
            isAdmin: userInfo?.role === RolesLevels.Admin,
          },
          {
            title: "Feedback",
            url: RoutesEnum.FEEDBACK,
            itemIcon: IconMessageReply,
            isAdmin: userInfo?.role === RolesLevels.Admin,
          },
          {
            title: "Compañias",
            url: RoutesEnum.COMPANIES,
            itemIcon: IconEdit,
            isAdmin: true,
          },
          {
            title: "Usuarios",
            url: RoutesEnum.USERS,
            itemIcon: IconUser,
            isAdmin:
              userInfo?.role === RolesLevels.Admin ||
              userInfo?.role === RolesLevels.MRM,
          },
        ],
      },
    ],
  };

  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col">
        <SidebarMenu>
          {data.navMain.map((item) => (
            <SidebarGroup key={item.title}>
              <SidebarGroupLabel className="text-[12px] font-inter">
                {item.title}
              </SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  {item.items.map(
                    (item) =>
                      item.isAdmin && (
                        <SidebarMenuItem key={item.title}>
                          <SidebarMenuButton onClick={() => navigate(item.url)}>
                            <item.itemIcon />
                            <span className="text-[14px] font-inter">
                              {item.title}
                            </span>
                          </SidebarMenuButton>
                        </SidebarMenuItem>
                      ),
                  )}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
